export default "__VITE_ASSET__D$kwSLlD__"